module.exports = __webpack_public_path__ + "img/logo.0b4ab6e9.jpg";